// src/data/teamData.js
const teamData = [
  {
    teamTitle: "Convenors",
    teamRank: 1,
    members: [
      {
        name: "Sri Pranathi",
        imageUrl: "/team/Sri Pranathi.jpg",
        email: "sripranathicheruvu@gmail.com",
        instagram: "sripranathiii",
        linkedin: "",
        role: "Convener"
      },
      {
        name: "Sk Md Kaif",
        imageUrl: "/team/Sk Md Kaif.jpg",
        email: "skmd.kaif.cd.cse23@itbhu.ac.in",
        instagram: "",
        linkedin: "",
        role: "Co-Convener"
      },
      {
        name: "Himanshu Malav",
        imageUrl: "/team/Himanshu Malav.jpg",
        email: "himanshu.malav.min23@itbhu.ac.in",
        instagram: "looking_4_mlv",
        linkedin: "https://www.linkedin.com/in/himanshu-malav-bb345a287/",
        role: "Co-Convenor"
      }
    ]
  },
  {
    teamTitle: "Council Secretary",
    teamRank: 2,
    members: [
      {
        name: "Adarsh Sharma",
        imageUrl: "/team/Adarsh Sharma.jpg",
        email: "adarsh.sharma.mst22@itbhu.ac.in",
        instagram: "adarshsharma_iit",
        linkedin: "https://www.linkedin.com/in/adarshsharmaiitbhu/",
        role: "General Secretary"
      },
      {
        name: "Suranjan Kumar ",
        imageUrl: "/team/Suranjan.png",
        email: "suranjan.kumar.civ23@itbhu.ac.in",
        instagram: "suranjan.26",
        linkedin: "https://www.linkedin.com/in/suranjan-kumar-a72a19355?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        role: "Joint General Secretary"
      },
      {
        name: "Simran Sharma",
        imageUrl: "/team/Simran Sharma.jpg",
        email: "simran.sharma.cd.civ23@itbhu.ac.in",
        instagram: "si.mrun",
        linkedin: "https://www.linkedin.com/in/simran-sharma-iitbhu?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
        role: "Joint General Secretary"
      }
    ]
  },
  {
    teamTitle: "Events Team",
    teamRank: 3,
    members: [
      {
        name: "Rounak Sarkar",
        imageUrl: "/team/Rounak Sarkar.jpg",
        email: "rounaksarkar9679@gmail.com",
        instagram: "ro_un_a_k",
        linkedin: "https://www.linkedin.com/in/rounak-sarkar-9b6250288?utm_source=share_via&utm_content=profile&utm_medium=member_android",
        role: "Events Team"
      },
      {
        name: "Utsav Gautam",
        imageUrl: "/team/Utsav Gautam.jpg",
        email: "utsav.gautam.eee23@itbhu.ac.in",
        instagram: "",
        linkedin: "",
        role: "Events Team"
      },
      {
        name: "Ayush Kumar",
        imageUrl: "/team/Ayushkumar.jpg",
        email: "ayush.kumar.cd.phy23@itbhu.ac.in",
        instagram: "_aayushku",
        linkedin: "https://www.linkedin.com/in/mr-ayush-kumar-305a012b6?utm_source=share_via&utm_content=profile&utm_medium=member_android",
        role: "Events Team"
      }
    ]
  },
  // {
  //   teamTitle: "Tech Team",
  //   teamRank: 4,
  //   members: [
  //     {
  //       name: "Roshan Mittal",
  //       imageUrl: "/team/roshan.jpeg",
  //       email: "roshan.mittal.che23@itbhu.ac.in",
  //       instagram: "roshanmittal_",
  //       linkedin: "www.linkedin.com/in/roshanmittal",
  //       role: "Tech Team"
  //     },{
  //       name: "Tejas Ashri",
  //       imageUrl: "/team/Tejas Ashri.jpeg",
  //       email: "tejasashri2004@gmail.com",
  //       instagram: "tejas_ashri",
  //       linkedin: "https://www.linkedin.com/in/tejas-ashri-326882216/",
  //       role: "Tech Team"
  //     }
  //   ]
  // },
  {
    teamTitle: "Content Team",
    teamRank: 9,
    members: [
      {
        name: "Vanshika Srivastava",
        imageUrl: "/team/Vanshika Srivastava.jpg",
        email: "vanshika.srivastava.mst23@itbhu.ac.in",
        instagram: "",
        linkedin: "",
        role: "Content Team"
      },
      {
        name: "S Adithyaraj",
        imageUrl: "/team/S Adithyaraj.jpg",
        email: "s.adithyaraj.mst23@itbhu.ac.in",
        instagram: "1_adithya_1",
        linkedin: "https://www.linkedin.com/in/sadithyaraj?utm_source=share_via&utm_content=profile&utm_medium=member_android",
        role: "Content Team"
      }
    ]
  },
  {
    teamTitle: "Design Team",
    teamRank: 8,
    members: [
      {
        name: "Aditya Kumar",
        imageUrl: "/team/Aditya Kumar.jpg",
        email: "aditya.kumar.cer23@itbhu.ac.in",
        instagram: "adi12_73",
        linkedin: "",
        role: "Design Team"
      }
    ]
  },
  {
    teamTitle: "Marketing Team",
    teamRank: 6,
    members: [
      {
        name: "Imran Khandakar",
        imageUrl: "/team/Imran Khandakar.jpg",
        email: "zubin677@gmail.com",
        instagram: "imran_khandakar07",
        linkedin: "https://www.linkedin.com/in/imran-khandakar-b09b48317/",
        role: "Marketing Team"
      }
    ]
  },
  {
    teamTitle: "PR Team",
    teamRank: 5,
    members: [
      {
        name: "Maheshwari",
        imageUrl: "/team/Maheshwari.jpg",
        email: "khandagale.maheshwarib.mst23@itbhu.ac.in",
        instagram: "",
        linkedin: "https://www.linkedin.com/in/maheshwari-khandagale-67a112285",
        role: "PR Team"
      },
      {
        name: "Rishi Raj",
        imageUrl: "/team/Rishi Raj.jpg",
        email: "rishi.raj.met23@itbhu.ac.in",
        instagram: "rishi1218raj",
        linkedin: "https://www.linkedin.com/in/rishi-raj-5013a728a/",
        role: "PR Team"
      }
    ]
  },
  {
    teamTitle: "Publicity Team",
    teamRank: 7,
    members: [
      {
        name: "Md Kaif",
        imageUrl: "/team/Md Kaif.jpg",
        email: "md.kaif.met23@itbhu.ac.in",
        instagram: "muhammadkaif1804",
        linkedin: "",
        role: "Publicity Team"
      }
    ]
  }
];

export default teamData;